import { render, staticRenderFns } from "./MoneyTableData.vue?vue&type=template&id=1c2d581a&scoped=true&"
import script from "./MoneyTableData.vue?vue&type=script&lang=js&"
export * from "./MoneyTableData.vue?vue&type=script&lang=js&"
import style0 from "./MoneyTableData.vue?vue&type=style&index=0&id=1c2d581a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2d581a",
  null
  
)

export default component.exports